// Exports the "table" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/table')
//   ES2015:
//     import 'tinymce/plugins/table'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ../~/tinymce/plugins/table/index.js
// module id = 555
// module chunks = 0